export enum TickCode {
  CAML_TICK_CODE = 33581,
  MLTT_TICK_CODE = 33600,
  MLCP_TICK_CODE = 33583,
  TRIPCAML_TICK_CODE = 32779,
  ZAPPING_TICK_CODE = 33592,
  CAML_URB_ESTAC_TICK_CODE = 713
}
